import ActionColumnRenderer from '../../../../app/Table/renderer/ActionColumnRenderer'
import HospitalInfraInvestigatorList from '../../../../../models/ReportModels/HospitalInfraInvestigatorList'
import moment from 'moment'

export default class HospitalInfraInvaestigatorColumnRenderer extends ActionColumnRenderer<HospitalInfraInvestigatorList> {
    getColumns() {
        return [
            {
                name: 'Name',
                selector: 'name',
            },
            {
                name: 'Claim Number',
                selector: 'claim_number',
            },
            {
                name: 'Modified On',
                selector: 'modified_on',
                format: (row: {}) => {
                    if (row instanceof HospitalInfraInvestigatorList) {
                        const Date = row.getModifiedOn()
                        if (Date !== null) return moment(Date).format('LL')
                    }
                },
            },
            {
                name: 'Actions',
                selector: '_id',
                grow: 0,
                width: '180px',
                cell: this.renderActionColumn,
            },
        ]
    }
}
